import 'whatwg-fetch';
import 'es6-promise/auto';
import 'jquery';
import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngSanitize from 'angular-sanitize';
import Rx from 'rx';
import rx from 'rx-angular';
import ngMaterial from 'angular-material';
import ngMdIcons from 'angular-material-icons';
import angularMoment from 'angular-moment';
import angularResizable from 'angular-resizable';
import ngMessages from 'angular-messages';
import 'angular-ui-router';
import 'angular-ui-calendar';
import 'fullcalendar';
import 'angular-input-masks';
import 'angular-animate';
import 'angular-aria';

import UserService from './services/user';
import loggedIn from './services/logged-in';
import progressBar from './services/progress-bar';
import Store from './services/rx-store';
import TradesService from './services/trades';
import BidsOffersService from './services/bids-offers';
import DashBoardService from './services/dashboard';
import $localstorage from './services/localstorage';
import $sessionstorage from './services/localstorage';
import WampCall from './services/wamp-rpc';
import acknowledge from './services/acknowledge';
import businessDays from './services/businessDays';
import $chatWamp from './services/chat-wamp';
import memberSearch from './services/member-search';
import menu from './services/menu';
import notifications from './services/notifications';
import $magicWamp from './services/magic-wamp';
import $thruway from './services/thruway';
import themePref from './services/theme-pref';
import PreviousReportService from './services/previous-report';
import WeekTradesService from './services/week-trades';

import LoginCtrl from './controllers/login';
import UserCtrl from './controllers/user';
import MenuBarCtrl from './controllers/menu-bar';
import MagicLoginCtrl from './controllers/magic-login';
import ProgressBarCtrl from './controllers/progress-bar';
import MemberUserCtrl from './controllers/member-user';
import MemberMenuCtrl from './controllers/member-menu';
import MasqueradeController from './controllers/masquerade';
import MemberAccountSettingsCtrl from './controllers/member-account-settings';
import MemberSettingsCtrl from './controllers/member-settings';
import AppInstallBannerCtrl from './controllers/app-install-banner';
import MemberAccountTradeCtrl from './controllers/member-account-trade';
import MemberAccountTradeNoteCtrl
  from './controllers/member-account-trade-note';
import MemberBidsCtrl from './controllers/member-bids';
import MemberBidsOffersCtrl from './controllers/member-bids-offers';
import MemberBidsOffersDetailCtrl
  from './controllers/member-bids-offers-detail';
import MemberCalendarCtrl from './controllers/member-calendar';
import MemberDeliveriesCtrl from './controllers/member-deliveries';
import MemberGyslCtrl from './controllers/member-gysl';
import MemberBoardCtrl from './controllers/member-board';
import MemberHomeCtrl from './controllers/member-home';
import NotificationsCtrl from './controllers/notifications';
import MembersCtrl from './controllers/members';
import MemberWeeklySummaryCtrl
  from './controllers/member-trades-weekly-summary';
import MemberTradesCtrl from './controllers/member-trades';
import MemberTradeRulesDetailCtrl
  from './controllers/member-trade-rules-detail';
import MemberTradeRulesCtrl from './controllers/member-trade-rules';
import MemberTradeDetailCtrl from './controllers/member-trade-detail';
import MemberSearchFieldCtrl from './controllers/member-search-field';
import MemberSearchCtrl from './controllers/member-search';
import MemberReceivablesCtrl from './controllers/member-receivables';
import MemberPaymentsCtrl from './controllers/member-payments';
import MemberPayablesCtrl from './controllers/member-payables';
import ContactCtrl from './controllers/contact';
import DialogController from './controllers/dialog';
import BoardFiltersDialogCtrl from './controllers/board-filters-dialog';
import QRCodeCtrl from './controllers/qr-code';

import vxDateFormat from './filters/vx-date-format';
import definitionTooltip from './filters/definition-tooltip';
import eggDefinitions from './data/egg-definitions.json';

import menuLink from './directives/menu-link';
import menuToggle from './directives/menu-toggle';
import scrollable from './directives/scrollable';
import rxDirective from './directives/rx';
import focusMe from './directives/focus-me';
import negativeDirective from './directives/negative';
import chartWidth from './directives/chart-width';
import marketTodayCard from './directives/market-today-card';
import balanceBar from './directives/balance-bar';
import regionFlowCard from './directives/region-flow-card';

// Theme tokens MUST load before any consumer (angular-material.min.css,
// fullcalendar, main.css). ExtractTextPlugin concatenates in import order.
import '../../../react/src/theme/eci-theme.css';
import 'angular-material/angular-material.min.css';
import 'fullcalendar/dist/fullcalendar.css';
import './styles/menu.css';
import './styles/print.css';
import './styles/main.css';

const themeRuntime = require('../../../react/src/theme/themeRuntime');
import moment from "moment";
import MemberRulesCompareCtrl from "./controllers/member-rules-compare";

const app = angular.module('app', [
  'ngCookies',
  'ngSanitize',
  'rx',
  'ui.router',
  'ngMaterial',
  'ngMdIcons',
  'angularMoment',
  'angularResizable',
  // 'leaflet-directive',
  'ngMessages',
  'ui.calendar',
  // 'vxChat',
  'ui.utils.masks'
]);

app.factory('UserService', ['$wamp', '$localstorage', UserService]);
app.factory('loggedIn', ['$rootScope', '$q', loggedIn]);
app.factory('progressBar', ['Store', '$timeout', progressBar]);
app.factory('Store', Store);
app.factory('TradesService', ['$wamp', 'progressBar', 'UserService', TradesService]);
app.factory('BidsOffersService', ['$wamp', 'progressBar', 'UserService', BidsOffersService]);
app.factory('DashBoardService', ['$wamp', '$q', DashBoardService]);
app.factory('$localstorage', ['$window', $localstorage]);
app.factory('$sessionstorage', ['$window', $sessionstorage]);
app.factory('WampCall', ['$wamp', WampCall]);
app.factory('acknowledge', ['$wamp', acknowledge]);
app.factory('businessDays', ['$wamp', businessDays]);
app.factory('$chatWamp', ['$wamp', $chatWamp]);
app.factory('memberSearch', memberSearch);
app.factory('menu', ['$location', 'UserService', menu]);
app.factory('notifications', ['Store', '$wamp', notifications]);
app.factory('$wamp', ['settings', '$rootScope', '$q', '$localstorage', $thruway]);
app.factory('themePref', themePref);
app.factory('PreviousReportService', ['$wamp', PreviousReportService]);
app.factory('WeekTradesService', ['$wamp', WeekTradesService]);

// app.provider('$magicWamp', $magicWamp);

app.controller('LoginCtrl', ['$scope', '$localstorage', '$wamp', '$http', 'settings', '$mdDialog', '$mdToast', 'UserService', '$state', '$timeout', LoginCtrl]);
app.controller('UserCtrl', ['$scope', 'UserService', 'settings', '$http', '$localstorage', UserCtrl]);
app.controller('MenuBarCtrl', ['$scope', 'UserService', '$mdSidenav', '$state', '$mdMedia', '$wamp', '$localstorage', MenuBarCtrl]);
app.controller('MagicLoginCtrl', ['$scope', '$magicWamp', '$localstorage', MagicLoginCtrl]);
app.controller('ProgressBarCtrl', ['$scope', 'progressBar', ProgressBarCtrl]);
app.controller('MemberMenuCtrl', ['$scope', '$rootScope', '$log', '$state', '$timeout', '$location', 'menu', 'acknowledge', '$wamp', '$mdDialog', MemberMenuCtrl]);
app.controller('MemberUserCtrl', ['$scope', 'UserService', '$mdSidenav', '$timeout', '$rootScope', MemberUserCtrl]);
app.controller('MasqueradeController', ['$scope', '$localstorage', '$wamp', '$state', 'UserService', MasqueradeController]);
app.controller('MemberAccountSettingsCtrl', ['$scope', 'progressBar', 'UserService', '$wamp', MemberAccountSettingsCtrl]);
app.controller('MemberSettingsCtrl', ['$scope', 'themePref', MemberSettingsCtrl]);
app.controller('MemberAccountTradeCtrl', ['$scope', 'WampCall', 'progressBar', '$stateParams', 'UserService', '$mdDialog', '$sce', '$timeout', '$wamp', '$mdMedia','$window', MemberAccountTradeCtrl]);
app.controller('MemberAccountTradeNoteCtrl', ['$scope', '$sce', '$mdDialog', '$wamp', '$stateParams', '$state', 'UserService', 'progressBar', MemberAccountTradeNoteCtrl]);
app.controller('MemberBidsCtrl', ['$scope', MemberBidsCtrl]);
app.controller('MemberBidsOffersCtrl', ['$scope', 'BidsOffersService', '$state', '$stateParams', '$anchorScroll', '$timeout', '$mdMedia', '$mdDialog', 'observeOnScope', 'businessDays', MemberBidsOffersCtrl]);
app.controller('MemberBidsOffersDetailCtrl', ['$scope', 'BidsOffersService', '$stateParams', '$uiViewScroll', '$mdMedia', MemberBidsOffersDetailCtrl]);
app.controller('MemberCalendarCtrl', ['$scope', '$wamp', '$stateParams', 'progressBar', '$state', '$timeout', 'uiCalendarConfig', '$mdMedia', MemberCalendarCtrl]);
app.controller('MemberDeliveriesCtrl', ['$scope', 'WampCall', 'progressBar', '$state', '$anchorScroll', '$mdMedia', MemberDeliveriesCtrl]);
app.controller('MemberGyslCtrl', ['$scope', '$wamp', 'observeOnScope', 'progressBar', MemberGyslCtrl]);
app.controller('MemberBoardCtrl', ['$scope', '$wamp', 'progressBar', MemberBoardCtrl]);
app.controller('MemberHomeCtrl', ['$scope', 'DashBoardService', 'BidsOffersService', 'TradesService', 'progressBar', 'UserService', '$wamp', '$timeout', '$filter', 'PreviousReportService', 'WeekTradesService', MemberHomeCtrl]);
app.controller('NotificationsCtrl', ['$scope', 'notifications', NotificationsCtrl]);
app.controller('MembersCtrl', ['$scope', MembersCtrl]);
app.controller('MemberWeeklySummaryCtrl', ['$scope', '$wamp', 'progressBar', MemberWeeklySummaryCtrl]);
app.controller('MemberTradesCtrl', ['$scope', 'TradesService', '$state', '$stateParams', '$anchorScroll', '$mdMedia', '$mdDialog', 'observeOnScope', 'businessDays', MemberTradesCtrl]);
app.controller('MemberTradeRulesDetailCtrl', ['$scope', '$sce', '$wamp', '$stateParams', MemberTradeRulesDetailCtrl]);
app.controller('MemberTradeRulesCtrl', ['$scope', '$sce', '$wamp', MemberTradeRulesCtrl]);
app.controller('MemberRulesCompareCtrl', ['$rootScope', 'UserService', '$mdSidenav', '$timeout', '$scope', MemberRulesCompareCtrl]);
app.controller('MemberTradeDetailCtrl', ['$scope', '$stateParams', 'TradesService', '$uiViewScroll', '$mdMedia', '$state', MemberTradeDetailCtrl]);
app.controller('MemberSearchFieldCtrl', ['$scope', '$state', '$stateParams', MemberSearchFieldCtrl]);
app.controller('MemberSearchCtrl', ['$scope', '$wamp', '$stateParams', 'progressBar', '$state', '$anchorScroll', MemberSearchCtrl]);
app.controller('MemberReceivablesCtrl', ['$scope', 'WampCall', 'progressBar', '$state', '$anchorScroll', '$mdMedia', MemberReceivablesCtrl]);
app.controller('MemberPaymentsCtrl', ['$scope', 'WampCall', 'progressBar', '$state', '$anchorScroll', '$mdMedia', MemberPaymentsCtrl]);
app.controller('MemberPayablesCtrl', ['$scope', 'WampCall', 'progressBar', '$state', '$anchorScroll', '$mdMedia', MemberPayablesCtrl]);
app.controller('ContactCtrl', ['$http', '$scope', ContactCtrl]);
app.controller('DialogController', ['$scope', '$mdDialog', DialogController]);
app.controller('BoardFiltersDialogCtrl', ['$scope', '$mdDialog', 'rows', 'categories', 'selection', BoardFiltersDialogCtrl]);
app.controller('QRCodeCtrl', ['$scope', '$stateParams', QRCodeCtrl]);

app.filter('vxDateFormat', ['moment', 'amMoment', 'angularMomentConfig', vxDateFormat]);
app.constant('eggDefinitions', eggDefinitions);
app.filter('eggDef', ['eggDefinitions', definitionTooltip]);

app.directive('menuLink', menuLink);
app.directive('menuToggle', menuToggle);
app.directive('scrollable', scrollable);
app.directive('rx', rxDirective);
app.directive('focusMe', focusMe);
app.directive('negative', negativeDirective);
app.directive('chartWidth', ['$parse', chartWidth]);
app.directive('marketTodayCard', [marketTodayCard]);
app.directive('balanceBar', [balanceBar]);
app.directive('regionFlowCard', ['$state', 'TradesService', regionFlowCard]);


// Components
app.component('menuBar', {
  template: require('./views/menu-bar.html')
});

app.component('appInstallBanner', {
  template: require('./views/app-install-banner.html'),
  controller: ['$localstorage', AppInstallBannerCtrl]
});

app.component('eciFooter', {
  template: require('./views/footer.html')
});

app.constant('settings', {
  // login_url: '/api3',
  // __API_HOST__ is injected at build time by webpack.DefinePlugin
  // (see webpack.config.js); defaults to www.eggs.org.
  login_url: 'https://' + __API_HOST__ + '/api3',
  wamp_url: 'wss://' + __API_HOST__ + '/app1?version=1.0.2023',
  // wamp_url: 'ws://127.0.0.1:9993',
  realm: 'org.eggs',
  auth_method: 'jwtauth',
  magic: {
    wamp_url: '/app1',
    realm: 'eci_magic',
    auth_method: 'eci_magic_auth'
  }
})
    .config(function ($stateProvider, $urlRouterProvider, $locationProvider) {

      $locationProvider.html5Mode({ enabled: true, requireBase: false }); //activate HTML5 Mode

      // Send any unknown URL to the 404 state
      $urlRouterProvider.otherwise(function ($injector, $location) {
        var missing = $location.url(); // preserve what they asked for
        window.location.replace('/404?path=' + encodeURIComponent(missing));
      });

      // Now set up the states
      $stateProvider
          .state('home', {
            url: "/",
            template: require("./views/home.html")
          })
          .state('about', {
            url: "/about",
            template: require("./views/about.html")
          })
          .state('resources', {
            url: "/resources",
            template: require("./views/resources.html")
          })
          .state('terms', {
            url: "/terms",
            template: require("./views/terms.html")
          })
          .state('privacy', {
            url: "/privacy",
            template: require("./views/privacy.html")
          })
          .state('contact', {
            url: "/contact",
            template: require("./views/contact.html"),
            controller: "ContactCtrl"
          })
          .state('meeting-registration', {
            url: "/meeting-registration-2026",
            template: require("./views/meeting-registration.html"),
          })
          .state('qr-rollup-001', {
            url: "/qr-rollup-001",
            template: require("./views/meeting-itinerary.html"),
          })
          .state('qr-code', {
            url: "/qr-code/:id",
            template: require("./views/qr-code.html"),
            controller: "QRCodeCtrl"
          })
          .state('qr', {
            url: "/qr/:id",
            template: require("./views/qr-code.html"),
            controller: "QRCodeCtrl"
          })
          .state('join', {
            url: "/join",
            template: require("./views/join.html")
          })
          .state('member', {
            url: "/member",
            data: {
              'selectedTab': 0
            },
            abstract: true,
            template: require(`./views/member-index.html`),
            resolve: {
              authorize: function (loggedIn, $wamp) {
                // if (!$wamp.connection.isConnected) {
                $wamp.open();
                // }
                return loggedIn;
              }
            }

          })
          .state('member.newbo', {
            url: '/newbo',
            template: require('./views/member-new-bo.html'),
          })
          //MEMBER GYSL
          .state('member.gysl', {
            url: "/gysl",
            template: require("./views/member-gysl.html"),
            controller: 'MemberGyslCtrl'
          })

          //MEMBER STAFF AREA
          .state('member.board', {
            url: "/board",
            template: require("./views/member-board.html"),
            controller: 'MemberBoardCtrl'
          })
          .state('member.staff', {
            url: "/staff",
            template: require("./views/member-staff.html")
          })

          //MEMBER DEFINITIONS
          .state('member.definitions', {
            url: "/egg-definitions",
            template: require("./views/member-egg-type-definitions.html"),
            controller: ['$scope', 'eggDefinitions', function ($scope, defs) {
              var pick = function (obj, keys) {
                return keys.map(function (k) { return { abbr: k, desc: obj[k] }; });
              };
              $scope.types = pick(defs.types, ['GNR','CA','TGL','PGL','EGL','CTN','NRBS','FRZN','LIQ']);
              $scope.colors = pick(defs.colors, ['W','BR','BL','-','NC','SA','SU','YK']);
              $scope.deliveries = pick(defs.deliveries, ['RD','HD','ND','ED','R1']);
              $scope.packaging = [
                { abbr: 'CO or CU', desc: 'Cases Oiled or Unoiled' },
                { abbr: 'PO or PU', desc: 'Pallets Oiled or Unoiled' },
                { abbr: 'RO or RU', desc: 'Racks Oiled or Unoiled' },
                { abbr: 'CN', desc: defs.packaging['CN'] },
                { abbr: 'CT', desc: defs.packaging['CT'] }
              ];
              $scope.other = pick(defs.other, ['AH']);
            }]
          })

          //MEMBER ACCOUNT AREA
          .state('member.account', {
            url: "/home",
            template: require("./views/member-home.html"),
            controller: 'MemberHomeCtrl'
          })

          //MEMBER ACCOUNT PAYABLES
          .state('member.account.payables', {
            url: "/payables",
            data: {
              'selectedTab': 1
            },
            views: {
              'payables': {
                template: require("./views/member-payables.html"),
                controller: 'MemberPayablesCtrl as payables'
              }
            }
          })
          .state('member.account.payables.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.payables.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })

          //MEMBER ACCOUNT RECEIVABLES
          .state('member.account.receivables', {
            url: "/receivables",
            data: {
              'selectedTab': 2
            },
            views: {
              'receivables': {
                template: require("./views/member-receivables.html"),
                controller: 'MemberReceivablesCtrl as receivables'
              }
            }
          })
          .state('member.account.receivables.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.receivables.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })

          //MEMBER ACCOUNT DELIVERIES
          .state('member.account.deliveries', {
            url: "/deliveries",
            data: {
              'selectedTab': 3
            },
            views: {
              'deliveries': {
                template: require("./views/member-deliveries.html"),
                controller: 'MemberDeliveriesCtrl as deliveries'
              }
            }
          })
          .state('member.account.deliveries.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.deliveries.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })

          //MEMBER ACCOUNT PAYMENTS
          .state('member.account.payments', {
            url: "/payments",
            data: {
              'selectedTab': 4
            },
            views: {
              'payments': {
                template: require("./views/member-payments.html"),
                controller: 'MemberPaymentsCtrl as payments'
              }
            }
          })
          .state('member.account.payments.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.payments.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })


          //MEMBER SEARCH AREA
          .state('member.account.search', {
            url: "/search/:query",
            data: {
              'selectedTab': 5
            },
            views: {
              'search': {
                template: require("./views/member-search.html"),
                controller: "MemberSearchCtrl"
              }
            }

          })
          .state('member.account.search.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.search.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })

          //MEMBER CALENDAR AREA
          .state('member.account.calendar', {
            url: "/calendar/:start/:query",
            data: {
              'selectedTab': 6
            },
            views: {
              'calendar': {
                template: require("./views/member-calendar.html"),
                controller: "MemberCalendarCtrl"
              }
            }

          })
          .state('member.account.calendar.trade', {
            url: "/trade/:id",
            template: require("./views/member-account-trade.html"),
            controller: "MemberAccountTradeCtrl"
          })
          .state('member.account.calendar.trade.note', {
            url: "/note/:noteId",
            controller: "MemberAccountTradeNoteCtrl"
          })

          //MEMBER ACCOUNT SETTINGS
          .state('member.account-settings', {
            url: "/setting",
            template: require("./views/member-account-settings.html"),
            controller: 'MemberAccountSettingsCtrl'
          })

          //MEMBER APPEARANCE / PREFERENCES
          .state('member.settings', {
            url: "/settings",
            template: require("./views/member-settings.html"),
            controller: 'MemberSettingsCtrl'
          })

          //MEMBER TRADES
          .state('member.trades', {
            data: {
              'reqTrading': true
            },
            url: "/trades/:report",
            template: require("./views/member-trades.html"),
            controller: 'MemberTradesCtrl'
          })
          .state('member.trades.detail', {
            data: {
              'reqTrading': true
            },
            url: "/:id",
            template: require("./views/member-trades-detail.html"),
            controller: 'MemberTradeDetailCtrl'
          })

          //MEMBER WEEKLY TRADE SUMMARY
          .state('member.trades-weekly', {
            data: {
              'reqTrading': true
            },
            url: "/trades-weekly",
            template: require("./views/member-trades-weekly-summary.html"),
            controller: 'MemberWeeklySummaryCtrl'
          })

          //MEMBER BIDS/OFFERS
          .state('member.bids-offers', {
            data: {
              'reqTrading': true
            },
            url: "/bids-offers/:report",
            template: require("./views/member-bids-offers.html"),
            controller: "MemberBidsOffersCtrl"
          })
          .state('member.bids-offers.detail', {
            data: {
              'reqTrading': true
            },
            url: "/:id",
            template: require("./views/member-bids-offers-detail.html"),
            controller: "MemberBidsOffersDetailCtrl"
          })

          //MEMBER TRADE Rules
          .state('member.trade-rules', {
            url: "/trade-rules",
            template: require("./views/member-trade-rules.html"),
            controller: "MemberTradeRulesCtrl"
          })
          .state('member.trade-rules.detail', {
            url: "/:page",
            template: require("./views/member-trade-rules-detail.html"),
            controller: "MemberTradeRulesDetailCtrl"
          })
        .state('member.trade-rules-compare', {
          url: "/rules/compare/:idA/:idB",
          template: require("./views/member-trade-rules-compare.html"),
          controller: "MemberRulesCompareCtrl"
        })
          .state('notFound', {
            url: '/404?path',
            template: require('./views/404.html'),
            controller: function ($scope, $stateParams) {
              $scope.requestedPath = $stateParams.path; // show what was missing (optional)
            }
          })
    });

app.config(function ($mdThemingProvider) {
  // Extend the red theme with a few different colors
  let eciGreenMap = $mdThemingProvider.extendPalette('light-green', {
    '500': '667733'
  });
  let eciOrangeMap = $mdThemingProvider.extendPalette('orange', {
    '400': 'D2772E'
  });
  // Register the new color palette map with the name <code>neonRed</code>
  $mdThemingProvider.definePalette('eciGreen', eciGreenMap);
  $mdThemingProvider.definePalette('eciOrange', eciOrangeMap);

  // Use that theme for the primary intentions
  $mdThemingProvider.theme('default').primaryPalette('eciGreen').accentPalette('eciOrange');

  // Dark theme — applied when the user / OS chooses dark mode. Light rendering
  // is unchanged because the default theme above is untouched.
  $mdThemingProvider.theme('eci-dark')
    .primaryPalette('eciGreen')
    .accentPalette('eciOrange')
    .backgroundPalette('grey')
    .warnPalette('red')
    .dark();

  // Required for runtime theme switching via md-theme="{{eciMdTheme}}".
  $mdThemingProvider.alwaysWatchTheme(true);

});

// Initialize the theme before the first digest. In dark mode we apply
// md-theme="eci-dark" on <body> so angular-material's runtime flips
// sidenav, dialogs, buttons, md-content, lists etc. dark. The md-toolbar
// in eci-dark theme would otherwise render with the eciGreen primary
// palette (olive) — we override that with CSS in main.css so toolbars
// stay brand-navy. In light mode md-theme stays empty so the existing
// cascade (and main.css's var(--eci-navy)) renders identically to today.
app.run(['$rootScope', function ($rootScope) {
  themeRuntime.initTheme();
  var effective = themeRuntime.getEffectiveMode();
  $rootScope.eciMdTheme = effective === 'dark' ? 'eci-dark' : '';
  // angular-material 1.1.x doesn't reliably re-apply theme classes to every
  // child component when md-theme on <body> flips at runtime, so a partial
  // update leaves toolbars/buttons/sidenav stuck on the old theme. Reload
  // when the effective mode actually changes — the boot path then applies
  // the new theme to every component consistently. The user's preference
  // lives in localStorage and survives the reload.
  var currentEffective = effective;
  window.addEventListener(themeRuntime.CHANGE_EVENT, function (ev) {
    var newEffective = (ev && ev.detail && ev.detail.effective) || themeRuntime.getEffectiveMode();
    if (newEffective !== currentEffective) {
      currentEffective = newEffective;
      window.location.reload();
    }
  });
}]);

// app.config(function WampConfig($wampProvider, settings) {
//   $wampProvider.init({
//     url: settings.wamp_url,
//     authmethods: [settings.auth_method],
//     realm: settings.realm,
//     max_retries: 3000,
//     max_retry_delay: 30,
//     retry_delay_growth: 1.1,
//     disable_digest: true
//
//     //Any other AutobahnJS options
//   });
// });

// Restrict navigation for users that can't trade
app.run(function ($rootScope, $timeout, $state, UserService) {

  $rootScope.$eventToObservable('$stateChangeStart')
      .combineLatest(UserService.subject)
      .subscribe(function ([change, user]) {
        let event = change[0];
        let toState = change[1];
        let canTrade = user.roles && user.roles.indexOf('trading') >= 0;

        if (toState.data && toState.data.reqTrading && !canTrade) {
          $state.go('member.account');
          event && event.preventDefault();
        }
      });
});

app.run(function ($wamp, $rootScope, $state, loggedIn, progressBar, $timeout, $localstorage) {

  let timeout;

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    progressBar.add('state-change');
    toState.href = $state.href(toState.name, toParams);
    $wamp.call('org.eggs.state_change', [{
      name: toState.name,
      url: toState.url,
      href: toState.href,
      controller: toState.controller,
      data: toState.data
    }, toParams]);
  });

  $rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {

    $timeout.cancel(timeout);

    timeout = $timeout(function () {
      progressBar.remove('state-change');
    }, 300);

  });

  if ($localstorage.get('ecitoken')) {
    $timeout(function () {
      $wamp.open();
    }, 500);
  }

  // //Reset the wamp connection if the browser goes offline.  Waiting for
  // autobahn can take a very long time. window.addEventListener('offline',
  // function () { console.log('offline'); $wamp.close(); });
  // window.addEventListener('online', function () { console.log('online');
  // $timeout(function () { if (!$wamp.connection.isConnected) { $wamp.open();
  // } }, 1000); });

});

app.run(function ($rootScope, $mdMedia, $state) {
  $rootScope.$mdMedia = $mdMedia;
  $rootScope.$state = $state;

  try {
    $rootScope.iframe = window.self !== window.top;
  }
  catch (e) {
    $rootScope.iframe = true;
  }
});

app.run(function ($rootScope, TradesService, UserService, BidsOffersService, DashBoardService, $mdDialog, $localstorage, settings, $http, $timeout, $wamp, $state) {

  let authFailureRetry = 0;
  let timer;
  let pastDueAlertShown = false;

  $rootScope.$on('$wamp.open', function () {
    // TradesService.load();
    UserService.load();
    //BidsOffersService.load();
    DashBoardService.load();
    authFailureRetry = 0;
    $timeout.cancel(timer);
    pastDueAlertShown = false;
  });

  UserService.subject.safeApply($rootScope, function (user) {
    $rootScope.user = user;
    $rootScope.refresh = user.roles && user.roles.indexOf('refresh') >= 0;
    $rootScope.trading = user.roles && user.roles.indexOf('trading') >= 0;
    $rootScope.pc = user.roles && user.roles.indexOf('pc') > 0;
    const roleValues = user.roles && user.roles[0] ? Object.values(user.roles[0]) : [];
    const pastdue = roleValues.indexOf('past.due') >= 0;

    if (pastdue && !pastDueAlertShown) {
      pastDueAlertShown = true;
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Account Past Due')
          .textContent('Your account is past due. Please contact ECI at (800) 872-3324 for assistance.')
          .ok('OK')
      );
    }
  }).subscribe();

  $rootScope.$on('$wamp.close', function (event, close) {
    if (close.details && close.details.reason === "org.eggs.session_ended") {

      $localstorage.del('ecitoken');
      $localstorage.del('authid');
      $localstorage.del('masqtoken');
      $localstorage.del('masqauthid');

      let confirm = $mdDialog.confirm()
      //.title('')
          .textContent(close.details.message)
          .ariaLabel(close.details.message)
          .ok('Okay');

      let logout = function () {
        $state.go('member.account');
        $timeout(function () {
          location.reload();
        }, 100);
      };

      $mdDialog.show(confirm).then(logout, logout);
    }

    //Attempt to reconnect 5 times if we get a not authorized error.  This is
    // needed encase the router restarts and this client tries to connect
    // before the auth provider is available
    if (close.details && close.details.reason === "wamp.error.not_authorized") {
      if (authFailureRetry <= 5) {
        timer = $timeout(function () {
          location.reload();
          authFailureRetry++;
        }, 500 * authFailureRetry);
      }
    }

  });

});

app.run(function ($wamp, UserService, $localstorage) {
  // Re-keyed login tokens (a role change on the internal side) arrive on a
  // progressive call that stays open for the session; each emission is the
  // new token. It used to be a per-person topic. If the call drops (backend
  // restart), come back for it after a moment.
  UserService.subject
      .take(1)
      .flatMap(function () {
        return fromRxJS5($wamp.thruway.progressiveCall('org.eggs.login_tokens', []))
            .map(res => res.args[0])
            .retryWhen(errors => errors.delay(3000))
            .repeatWhen(completions => completions.delay(3000));
      })
      .subscribe(function (token) {
        $localstorage.del('authid');
        $localstorage.del('masqtoken');
        $localstorage.del('masqauthid');
        $localstorage.del('ecitoken');

        $localstorage.set('ecitoken', token);
      });
});

app.config(['$compileProvider', function ($compileProvider) {
  $compileProvider.debugInfoEnabled(false);  //Uncomment for production
}]);

app.constant('angularMomentConfig', {
  timezone: 'America/New_York'
});

app.filter('nospace', function () {
  return function (value) {
    return (!value) ? '' : value.replace(/ /g, '');
  };
})
//replace uppercase to regular case
    .filter('humanizeDoc', function () {
      return function (doc) {
        if (!doc) {
          return;
        }
        if (doc.type === 'directive') {
          return doc.name.replace(/([A-Z])/g, function ($1) {
            return '-' + $1.toLowerCase();
          });
        }

        return doc.label || doc.name;
      };
    });

app.run(function ($animate) {
  $animate.enabled(false);
});

export function fromRxJS5($rxjs5observable) {
  return new Rx.Observable.create((observer) => {
    let sub = $rxjs5observable.subscribe(
        (v) => observer.onNext(v),
        (e) => observer.onError(e),
        () => observer.onCompleted()
    );

    return () => {
      sub.unsubscribe();
    }
  });
}

export function isValidDate(dateString) {
  // Attempt to parse the date using Moment.js
  const parsedDate = moment(dateString, moment.ISO_8601, true);

  // Check if the parsed date is valid
  return parsedDate.isValid();
}

export function getPreviousWeekday(date = new Date()) {
  const oneDay = 24 * 60 * 60 * 1000; // milliseconds in a day
  const dayOfWeek = date.getDay(); // 0: Sunday, 1: Monday, ..., 6: Saturday

  // Adjust if today is Sunday (0) or Saturday (6)
  let daysToSubtract = dayOfWeek === 0 ? 2 : 1; // Subtract 2 days for Sunday, 1 day for other weekdays
  if (dayOfWeek === 1) daysToSubtract++; // If today is Monday, we need to subtract an additional day

  // Loop backwards until we find a valid previous weekday
  let previousDay = new Date(date.getTime() - (oneDay * daysToSubtract));
  while (previousDay.getDay() === 0 || previousDay.getDay() === 6) {
    // If the previous day is Saturday (6) or Sunday (0), subtract one more day
    previousDay = new Date(previousDay.getTime() - oneDay);
  }

  return previousDay;
}

if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

// Meeting Form Submission Resubmit

(function () {

  const resubmitted = localStorage.getItem('resubmitted');
  if (resubmitted === 'yes') {
    return;
  }

  const submitted = localStorage.getItem('submitted');
  const token = localStorage.getItem('ecitoken');
  const stateString = localStorage.getItem('state');
  if (!stateString) {
    return;
  }

  const state = JSON.parse(stateString);

  state.resubmitted = 'yes';
  state.token = token;
  state.submitted = submitted;

  const body = JSON.stringify(state);

  const url = '/api3/meeting/submit_blob';

  fetch(url, {
    method: "POST",
    mode: "no-cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: body,
  })
      .then(() => {
        localStorage.setItem('resubmitted', 'yes');
      })
      .catch(e => {
        console.log(e);
      });
})();
